export default __webpack_public_path__ + "static/media/f0d37054c0f8489d70c301789bd0cdf9.58de2789.png";